import React from 'react'
import { Nav, Tab } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import useTranslation from '@/Hooks/UseTranslation'
import { useProject } from '@/Hooks/UseProject'

import './ProjectIndicators.scss'

type IndicatorTab = 'ppc' | 'cnc'

interface Props {
  activeTab: IndicatorTab
}

const ProjectIndicatorsNav = ({ activeTab }: Props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const { project_id } = useProject()

  const navigate = (tab: IndicatorTab) => {
    if (!project_id || tab === activeTab) return

    history.push(`/project/${project_id}/indicators/${tab}`)
  }

  return (
    <div className="ul-widget__head-nav">
      <Tab.Container>
        <Nav as="ul" className="nav-tabs nav-tabs-line nav-tabs-bold">
          <Nav.Item as="li">
            <Nav.Link active={activeTab === 'ppc'} onClick={() => navigate('ppc')}>
              <span className="icon-ppc_indicador" />{' '}
              {t('NAVIGATION:IndicatorsPPC')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link active={activeTab === 'cnc'} onClick={() => navigate('cnc')}>
              <span className="icon-cnc_recurso" />{' '}
              {t('NAVIGATION:IndicatorsCNC')}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Tab.Container>
    </div>
  )
}

export default ProjectIndicatorsNav
